(function () {
	'use strict';

	a3_cabin_reports.factory('AircaftPositionsFactory', AircaftPositionsFactory)

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name AircaftPositionsFactory
    * @description 
    *   Add, Update, Delete and Get AircaftPositions.
    * @ngInject
    */
	function AircaftPositionsFactory(GenericService) {

        /**
        * Initialize the AircaftPositions
        * @memberof AircaftPositionsFactory
        */
		function AircaftPositions() {
			this.FlightId = null;
			this.PreviousFlightNo = null;
			this.PreviousStation = null;
			this.PreviousSTA = null;
			this.PreviousETA = null;
			this.PreviousATA = null;
			this.PreviousGATE = null;
			this.PreviousSTAND = "";
			this.PreviousSTANDArrival = "";
			this.NextFlightNo = null;
			this.NextStation = null;
			this.NextSTD = null;
			this.NextETD = null;
			this.NextATD = null;
			this.NextGATE = null;
			this.NextSTAND = "";
			this.NextSTANDArrival = "";

			this.GetId = GetId;
		}

		var objType = 'aircaftpositions';
		var objCallback = AircaftPositions;

		var service =
		{
			getAircaftPositionsFromStorage: getAircaftPositionsFromStorage,
			setAircaftPositionsToStorage: setAircaftPositionsToStorage,
			clearAircaftPositionsFromStorage: clearAircaftPositionsFromStorage,
			getAircaftPositionsByFlightId: getAircaftPositionsByFlightId,
			updateAircraftPositionsToStorage: updateAircraftPositionsToStorage,
			cleanOldData: cleanOldData
		};

        /**
         * Overide default get Id
         * @memberof AircaftPositionsFactory
         * @returns {number} Id 
         */
		function GetId() {
			return this.FlightId;
		}



        /**
         * Get messages
         * @memberof AircaftPositionsFactory
         * @returns {Array} Aircaft Positions 
         */
		function getAircaftPositionsFromStorage() {
			return GenericService.list(objType, objCallback);
		}

        /**
         * Save Aircaft Positions to storage
         * @memberof AircaftPositionsFactory
         * @param {Array} messages A list of Aircaft Positions
         */
		function setAircaftPositionsToStorage(aircaftPositions) {
			GenericService.saveAll(aircaftPositions, objType, objCallback);
		}

        /**
         * Remove the Aircaft Positions of  the local storage
         * @memberof AircaftPositionsFactory
         */
		function clearAircaftPositionsFromStorage() {
			GenericService.removeAll(objType, objCallback);
		}

        /**
         * Get Aircaft Positions of this flight
         * @memberof AircaftPositionsFactory
         * @returns {Object} Aircaft Positions 
         */
		function getAircaftPositionsByFlightId(flightId) {
			return GenericService.get(flightId, objType, objCallback);
		}

		/**
		* Update Aircraft Position to storage
		* @memberof AircaftPositionsFactory
		* @param {object} aircraftPositions  Aircraft Positions
		*/
		function updateAircraftPositionsToStorage(aircraftPositions, flightId) {
			if (GenericService.get(flightId, objType, objCallback)){
				GenericService.save(aircraftPositions, objType, objCallback);
			}
			else if (aircraftPositions != null)
				GenericService.add(aircraftPositions, objType, objCallback);
		}

		/**
         * Clean ls from old flights aircraft positions
         * @param {array} flights Synced flights
         */
		 function cleanOldData(responseFlightIds){
            var previousAircaftPositions = getAircaftPositionsFromStorage();
            previousAircaftPositions = previousAircaftPositions.filter(x => responseFlightIds.includes(x.FlightId));
            setAircaftPositionsToStorage(previousAircaftPositions);
        }

		return service;
	}

})();